import React, { useEffect, useState, useContext } from 'react';
import { CircularProgress } from '@material-ui/core';
import TxFormGenerator from '../../generators/TxFormGenerator';
import { GlobalsContext } from '../../store/Globals';
import { InputTypes, InputType } from '../../store/inputs/types';

import { Container, LoadingContainer } from './styles';
import { Caller } from '../../types/Caller';

const TxFormScreen: React.FC<{
  tx: {
    label: string;
    tag: string;
    method: string;
    args: Record<string, any>[] | Record<string, any>;
    description: string;
    callers: Caller[] | string[];
  };
}> = ({ tx }) => {
  const globals = useContext(GlobalsContext);
  const [inputs, setInputs] = useState<InputTypes[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getTxInputs = async () => {
      const newInputs = tx.args as InputTypes[];

      setInputs(
        newInputs.map((ip: InputType) => ({
          ...ip,
          dataType: globals.dataTypeBase(ip.dataType),
          dropDownValues: globals.getDropDownValues(ip.dataType),
        })),
      );
      setLoading(false);
    };
    if (tx.args) {
      getTxInputs();
    }
  }, [tx.tag, tx.args, globals]);

  if (loading)
    return (
      <LoadingContainer>
        <CircularProgress />
      </LoadingContainer>
    );

  return (
    <Container headerHeight={globals.headerHeight}>
      <TxFormGenerator tx={{ name: tx, inputs }} />
    </Container>
  );
};

export default TxFormScreen;
